import styled from "styled-components"
import { media } from "../../../../styles"

import { Link } from "gatsby"

export const NavbarContainer = styled.nav`
  width: 100%;

  background-color: ${prop =>
    prop.scrolledNav > 0 ? "var(--color-blue)" : "transparent"};

  padding: 0 5rem;

  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;

  z-index: ${prop => (prop.scrolled > 0 ? "5" : "4")};

  transition: ${prop => (prop.bgTransition ? "all 0.3s ease" : "none")};

  ${media.laptop`
padding-right: 15rem;
  `}

  ${media.tabport`
    height: 90px;
    display:flex;
    align-items:center;
    width: 100%;
  `}

  ${media.phone`
padding-right: 10rem;

  `}

  ${media.phonesmall`
  padding: 1rem 1.5rem;
  height: 8rem;
  `}
`

export const NavbarInnerContainer = styled.div`
  max-width: 200rem;
  padding: 0 2rem;
  margin: 0 auto;

  display: flex;

  justify-content: space-between;

  ${media.tabport`

    width: 100%;
  `}
`

export const NavbarLogoContainer = styled.div`
  display: flex;
  align-items: center;

  & svg {
    width: 5rem;

    ${media.phonesmall`
    width: 3.5rem;
  `}
  }

  & a {
  }

  position: relative;
  z-index: 3;
`
export const NavbarLogoText = styled.span`
  font-family: var(--font-body);
  font-size: 7.7rem;

  color: var(--color-white);

  text-transform: uppercase;
  margin-left: 0.2rem;

  opacity: ${prop => (prop.scrolled > 0 ? "0" : "1")};
  transition: opacity 0.3s ease;

  ${media.tabland`
    display: none;
  `}
`
export const NavbarLogoBar = styled.div`
  width: 0.4rem;
  height: 7rem;
  background-color: var(--color-green);
  margin-left: 1rem;

  transform: ${prop =>
    prop.scrolled > 0 ? "translateX(-20.5rem)" : "translateX(0)"};
  transition: transform 0.5s ease;

  ${media.tabland`
    transform: translateX(0);
  `}

  ${media.tabport`
    transform: translateX(0);
    display: none;
  `}


  ${media.phone`
    display: none;
  `}
`
export const NavbarLogoBrand = styled.span`
  font-family: var(--font-body);
  font-size: 3rem;

  color: var(--color-white);

  text-transform: uppercase;
  margin-left: 1.5rem;

  transform: ${prop =>
    prop.scrolled > 0 ? "translateX(-20.5rem)" : "translateX(0)"};
  transition: transform 0.5s ease;

  ${media.tabland`
  transform: none;
  `}

  ${media.tabport`
    transform: translateX(0);
    display: none;
  `}

  ${media.phone`
    display: none;
  `}
`

export const NavbarList = styled.ul`
  display: flex;
  width: 100%;
  max-width: 100rem;
  align-items: center;

  justify-content: space-between;

  list-style: none;

  position: relative;
  z-index: 3;

  margin-left: 5rem;

  ${media.laptop`
  justify-content:flex-end;
  `}

  ${media.phone`
  margin-left: 3rem;
  `}

  ${media.phonesmall`
  margin: 0 6rem 0 1rem;
  `}
`
export const NavbarItem = styled.li`
  font-size: var(--font-size-nav-item);
  font-family: var(--font-body);
  color: var(--color-white);

  text-transform: uppercase;
  cursor: pointer;
`
export const NavbarLink = styled(Link)`
  color: var(--color-white);
  text-decoration: none;
  ${media.laptop`
  display:none;
  `}
`

export const NavbarMobileBtn = styled.div`
  position: relative;
  z-index: 999;

  width: 4rem;
  height: 2.5rem;

  margin-left: 4rem;

  cursor: pointer;

  display: none;

  ${media.laptop`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  `}

  ${media.phonesmall`
  margin-left:1.5rem;
  width: 3rem;
  `}
`

export const NavbarMobileBtnLine = styled.div`
  width: 100%;
  height: 0.3rem;
  background-color: var(--color-white);
`
